export default "<countdown #cd [config]=\"config\" (event)=\"countdownHandler($event)\"></countdown>\n"